import { NotesTargetPanel } from '@/components/notes/notes-target-panel';
import type { NoteViewer } from '@/lib/notes-queries';
import type { MatrixFolder } from '@mss_creator/shared';
import { Icon } from '@pms-digital/design-system';

export interface FolderNotesPanelProps {
  folder: MatrixFolder;
  companyId: string;
  companyName: string;
  viewer: NoteViewer;
  onClose: () => void;
  /** The clock of the relative dates; tests pin it. */
  now?: Date;
}

/**
 * The notes of an open folder, to the right of the grid (issue #19, planche
 * 15): the same panel as the Notes tab of a matrix, scoped on the folder.
 */
export function FolderNotesPanel({
  folder,
  companyId,
  companyName,
  viewer,
  onClose,
  now,
}: FolderNotesPanelProps) {
  return (
    <aside
      aria-label="Notes du dossier"
      className="w-full shrink-0 self-start rounded-lg border-2 border-gray-100 bg-white p-3 shadow-sm xl:w-[320px]"
    >
      <div className="mb-2 flex items-center gap-1">
        <Icon name="chat_bubble" size={16} />
        <h3 className="flex-1 font-semibold text-caption">Notes du dossier</h3>
        <button
          type="button"
          aria-label="Fermer les notes"
          onClick={onClose}
          className="rounded-sm p-0 text-gray-600 hover:bg-gray-100 hover:text-noir focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bleu-nuit"
        >
          <Icon name="close" size={16} />
        </button>
      </div>
      <NotesTargetPanel
        scope={{ type: 'folder', folderId: folder.id }}
        targetLabel={`Dossier ${folder.name}`}
        companyId={companyId}
        companyName={companyName}
        viewer={viewer}
        {...(now ? { now } : {})}
      />
    </aside>
  );
}
